import React from "react";
import { Switch } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
    root: {
        width: "56px",
        height: "28px",
        padding: "0px",

    },
    switchBase: {
        color: "#818181",
        paddingTop: "0px",
        paddingBottom:"0px",
        paddingLeft:"1px",
        paddingRight:"1px",

        "&$checked": {
            "& + $track": {
                backgroundColor: "#086ea1"
            }
        }
    },
    thumb: {
        width: "22px",
        height: "22px",
        margin: "3px",
        boxShadow: "0 2px 2px 0 rgba(0, 0, 0, 0.12), 2px 3px 7px 0 rgba(0, 0, 0, 0.24)",
        backgroundColor: "#fff",
    },
    track: {
        borderRadius: "20px",
        border: "solid 1px #7c8790",
        backgroundColor: "#f9fafa",
        opacity: "1 !important",
        "&:after, &:before": {
            color: "white",
            fontSize: "12px",
            position: "absolute",
            top: "6px",
            fontFamily: "Nimbus Sans Novus Regular",
            fontWeight: "bold"
        },
        "&:after": {
            content: "'On'",
            left: "8px"
        },
        "&:before": {
            content: "'Off'",
            right: "8px",
            fontFamily: "Nimbus Sans Novus Regular",
            fontSize: "12px",
            fontWeight: "bold",
            color: "#3b4b59"
        }
    },
    checked: {
        color: "#23bf58 !important",
        transform: "translateX(26px) !important"
    }
});

export default function ToggleSwitch(props:any) {
    const classes = useStyles();

    return (
        <div>
            <Switch
                classes={{
                    root: classes.root,
                    switchBase: classes.switchBase,
                    thumb: classes.thumb,
                    track: classes.track,
                    checked: classes.checked
                }}
                checked={props.checked}
                onChange={props.onChange}
                name={props.name}
                inputProps={{ "aria-label": "secondary checkbox" }}
            />
        </div>
    );
}
